import React, { useState, useEffect } from 'react';

const MainFooter = () => {
  const [currentLang, setCurrentLang] = useState('ar');

  useEffect(() => {
    const checkLanguage = () => {
      const select = document.querySelector('.goog-te-combo');
      if (select && select.value === 'en') {
        setCurrentLang('en');
      } else {
        setCurrentLang('ar');
      }
    };

    checkLanguage();
    const observer = new MutationObserver(checkLanguage);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  const toggleLanguage = () => {
    const select = document.querySelector('.goog-te-combo');
    if (select) {
      if (currentLang === 'ar') {
        // Switch to English
        select.value = 'en';
        setCurrentLang('en');
        select.dispatchEvent(new Event('change'));
      } else {
        // Switch back to Arabic - clear cookies and reload
        document.cookie = "googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        document.cookie = "googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=" + window.location.hostname + ";";
        document.cookie = "googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=." + window.location.hostname + ";";
        
        // Force page reload to restore Arabic
        window.location.reload();
      }
    }
  };

  return (
    <>
      <div className="grow"></div>
      
      <footer className="flex justify-between lg:justify-center lg:gap-16 mt-8 items-center w-screen py-8 px-10 h-10">
        {/* Language Toggle - Fixed position */}
        <div className="fixed bottom-4 left-4 lg:bottom-8 lg:left-8 z-50">
          <button
            onClick={toggleLanguage}
            className="flex items-center gap-2 px-4 py-2 bg-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 border border-gray-200"
          >
            {currentLang === 'ar' ? (
              <>
                <span className="text-sm font-medium text-gray-700">English</span>
              </>
            ) : (
              <>
                <span className="text-sm font-medium text-gray-700">العربية</span>
              </>
            )}
          </button>
        </div>

        <div className="text-sm text-gray-500">© Copyright Acts</div>
        
        <div className="flex">
          <a
            href="https://www.facebook.com/profile.php?id=100089265053519&mibwxtid=ZbWKwL"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:scale-110 transition-all"
          >
            <img
              src="https://i.ibb.co/3fmF4zH/icons8-facebook-48.png"
              alt="Facebook"
              className="w-9"
            />
          </a>
          <div className="w-5"></div>
          <a
            href="https://wa.me/message/K5BD6QOI2BBYE1"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:scale-110 transition-all"
          >
            <img
              src="https://i.ibb.co/k2rf8LM/icons8-whatsapp-48-1.png"
              alt="WhatsApp"
              className="w-9"
            />
          </a>
        </div>
      </footer>
    </>
  );
};

export default MainFooter;